import * as React from "react";
class Footer extends React.Component {
    render(){
        return(
            <footer>
                <div className="container">
                    <div className="flex justify-between items">
                        <div className="item flex justify-between">
                            <ul className="nav">
                                <li>
                                    <a href="#">how it works</a>
                                </li>
                                <li>
                                    <a href="#">features</a>
                                </li>
                                <li>
                                    <a href="#">contact</a>
                                </li>
                                <li>
                                    <a href="#">sign in</a>
                                </li>
                            </ul>
                            <div className="connected">
                                <span className="color-purple-light">stay connected</span>
                                <form action="" className="flex align-center mt-10 email-form">
                                    <div className="text-field primary grey no-margin">
                                        <input type="text" placeholder="email address"/>
                                    </div>
                                    <button type="submit" className="btn filled primary w-xxxs h-lg">send</button>
                                </form>
                            </div>
                        </div>
                        <div className="info">
                            <span className="color-purple-light">questions? </span>
                            <a href="mailto:info@strada.ai">info@strada.ai</a>
                            <p className="copyright">© strada technologies Inc.</p>
                            <ul className="policy">
                                <li>
                                    <a href="#">Terms of Service</a>
                                </li>
                                <li>
                                    <a href="#">Privacy Policy</a>
                                </li>
                            </ul>
                            <div className="logo">
                                <a href="#" className="logo-text lg">strada</a>
                            </div>
                        </div>
                    </div>
                </div>
            </footer>
        )
    }
}

export default Footer;


// WEBPACK FOOTER //
// ./src/components/Homepage/Footer.tsx